import { useCallback, useEffect, useState } from 'react';
import { getOrganizationData } from 'services/bussines';
import { IorganizationBusinessData } from 'types/bussines';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

export const useOrganizationInfo = (organizationId?: number) => {
  const [organizationInfo, setOrganizationInfo] = useState<IorganizationBusinessData>();
  const [isLoading, setIsLoading] = useState(false);

  const getOrganizationInfo = useCallback(async organizationId => {
    if (!organizationId) return;
    setIsLoading(true);
    try {
      const response = await getOrganizationData(Number(organizationId));
      if (response) setOrganizationInfo(response);
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getOrganizationInfo(organizationId);
  }, [organizationId]);

  return { organizationInfo, isLoading };
};
